import type { AxiosResponse } from 'axios';
import axios from 'axios';
import dayjs from 'dayjs';

let diffSecFromServer = 0;
let catchedServerDateInterceptorId: number | null = null;

export const catchServerDateInterceptor = (response: AxiosResponse) => {
  const serverDate = response.headers.date;
  serverDate
  && typeof window !== 'undefined'
  && (diffSecFromServer = dayjs().tz('GMT').diff(dayjs(serverDate), 'second'));
  return response;
};

catchedServerDateInterceptorId = axios.interceptors.response.use(catchServerDateInterceptor);

export const resetCatchServerDateInterceptor = () => {
  catchedServerDateInterceptorId && axios.interceptors.response.eject(catchedServerDateInterceptorId);
  const newInterceptorId = axios.interceptors.response.use(catchServerDateInterceptor);
  catchedServerDateInterceptorId = newInterceptorId;
};

export class ServerDate extends Date {
  constructor(...args: Parameters<typeof Date>) {
    const origin = new Date(...args);
    super(+origin - ServerDate.diffSec * 1000);
  }

  static get diffSec() {
    return diffSecFromServer;
  }
}
